const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/account/login-log.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/account/login-log.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { LoginLogFilterParamSchema } from '@apps/main/features/user/pages/account/login-log-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/account/login-log')({
  validateSearch: LoginLogFilterParamSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});